import { Box, Typography } from "@mui/material";

import { findFee } from "../../helpers/acquirer";
import { formatTransactionFee } from "../../helpers/transaction";
import { Acquirer } from "../../interfaces/acquirer";

export function IntegrationItem({ data }: { data: Acquirer }) {
    const pixFee = findFee(data, "pix");
    const cardFee = findFee(data, "card");

    return (
        <Box border="1px solid" borderColor="grey.200" borderRadius={2} p={2}>
            <Box display="flex" justifyContent="space-between" mb={1}>
                <Box>
                    <Typography fontWeight={600}>{data.name}</Typography>
                    <Typography
                        hidden={!data?.description}
                        variant="body2"
                        color="text.secondary"
                    >
                        {data?.description}
                    </Typography>
                </Box>
                <Box width={8} height={8} borderRadius="50%" bgcolor="black" />
            </Box>

            <Box display="flex" justifyContent="space-between">
                <Typography variant="body2">PIX</Typography>
                <Typography>
                    {formatTransactionFee(
                        pixFee?.fee_percentage,
                        pixFee?.fixed_fee
                    ) || "-"}
                </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between">
                <Typography variant="body2">Cartão</Typography>
                <Typography>
                    {formatTransactionFee(
                        cardFee?.fee_percentage,
                        cardFee?.fixed_fee
                    ) || "-"}
                </Typography>
            </Box>
        </Box>
    );
}
